import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { AuthState } from "@/src/features/auth/types";

type SetCredentialsPayload = {
  accessToken: string;
  userId: number | null;
};

const initialState: AuthState = {
  accessToken: null,
  userId: null,
  isAuthenticated: false,
  isInitialized: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<SetCredentialsPayload>) => {
      state.accessToken = action.payload.accessToken;
      state.userId = action.payload.userId;
      state.isAuthenticated = true;
      state.isInitialized = true;
    },
    clearCredentials: (state) => {
      state.accessToken = null;
      state.userId = null;
      state.isAuthenticated = false;
      state.isInitialized = true;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;

export default authSlice.reducer;
